import { render, staticRenderFns } from "./purchaseAmountTrend.vue?vue&type=template&id=72ff34fc&scoped=true"
import script from "./purchaseAmountTrend.vue?vue&type=script&lang=js"
export * from "./purchaseAmountTrend.vue?vue&type=script&lang=js"
import style0 from "./purchaseAmountTrend.vue?vue&type=style&index=0&id=72ff34fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ff34fc",
  null
  
)

export default component.exports